<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  service: { type: Object, default: null },
});

const { t } = useI18n();
const eventLabel = event =>
  ({
    quote: t('NUCLEO_WORK_ORDERS.DETAIL.EVENTS.QUOTE'),
    approval: t('NUCLEO_WORK_ORDERS.DETAIL.EVENTS.APPROVAL'),
    schedule: t('NUCLEO_WORK_ORDERS.DETAIL.EVENTS.SCHEDULE'),
    start: t('NUCLEO_WORK_ORDERS.DETAIL.EVENTS.START'),
    evidence: t('NUCLEO_WORK_ORDERS.DETAIL.EVENTS.EVIDENCE'),
    completion: t('NUCLEO_WORK_ORDERS.DETAIL.EVENTS.COMPLETION'),
    acceptance: t('NUCLEO_WORK_ORDERS.DETAIL.EVENTS.ACCEPTANCE'),
    note: t('NUCLEO_WORK_ORDERS.DETAIL.EVENTS.NOTE'),
    dispute: t('NUCLEO_WORK_ORDERS.DETAIL.EVENTS.DISPUTE'),
    rework: t('NUCLEO_WORK_ORDERS.DETAIL.EVENTS.REWORK'),
    cancel: t('NUCLEO_WORK_ORDERS.DETAIL.EVENTS.CANCEL'),
    status_change: t('NUCLEO_WORK_ORDERS.DETAIL.EVENTS.STATUS_CHANGE'),
    invoice: t('NUCLEO_WORK_ORDERS.DETAIL.EVENTS.INVOICE'),
    payment: t('NUCLEO_WORK_ORDERS.DETAIL.EVENTS.PAYMENT'),
  })[event] || event;
const formatDateTime = value =>
  value
    ? new Intl.DateTimeFormat('pt-BR', {
        dateStyle: 'short',
        timeStyle: 'short',
      }).format(new Date(value))
    : '';
</script>

<template>
  <section
    class="rounded-lais border border-lais-border-soft bg-white shadow-lais-card"
  >
    <header class="border-b border-lais-border-soft px-5 py-4">
      <h2
        class="font-redHatDisplay text-lais-heading-sm font-semibold text-lais-text"
      >
        {{ t('NUCLEO_WORK_ORDERS.DETAIL.HISTORY.TITLE') }}
      </h2>
      <p v-if="service" class="mt-1 text-sm text-lais-text-muted">
        {{ service.nome }}
      </p>
    </header>
    <div
      v-if="!service?.historico?.length"
      class="p-5 text-sm text-lais-text-muted"
    >
      {{ t('NUCLEO_WORK_ORDERS.DETAIL.HISTORY.EMPTY') }}
    </div>
    <ol v-else class="divide-y divide-lais-border-soft">
      <li
        v-for="event in service.historico"
        :key="event.id"
        class="space-y-2 p-5"
      >
        <div class="flex flex-wrap items-center justify-between gap-2">
          <strong class="text-sm text-lais-text">{{
            eventLabel(event.event_type)
          }}</strong>
          <time class="text-xs text-lais-text-muted">{{
            formatDateTime(event.occurred_at)
          }}</time>
        </div>
        <p v-if="event.message" class="text-sm text-lais-text-body">
          {{ event.message }}
        </p>
        <p v-if="event.actor?.name" class="text-xs text-lais-text-muted">
          {{ event.actor.name }}
        </p>
        <a
          v-for="file in event.files"
          :key="file.id"
          :href="file.url"
          target="_blank"
          rel="noopener noreferrer"
          class="block text-sm text-lais-link hover:text-lais-link-hover"
        >
          {{ file.filename }}
        </a>
      </li>
    </ol>
  </section>
</template>
